import { ReadingStatus } from 'infrastructure/enums';
import i18n from 'infrastructure/i18n';
import classNames from 'classnames';
import { Flex, Typography } from 'antd';

import s from './styles.module.scss';

import type { FC } from 'react';

const { Text } = Typography;

interface Props {
  status: ReadingStatus;
  count?: number;
  disable?: boolean;
}

const labels = {
  [ReadingStatus.Critical]: i18n.t('labels.critical'),
  [ReadingStatus.Risk]: i18n.t('labels.at-risk'),
  [ReadingStatus.Normal]: i18n.t('labels.normal'),
};

const ReadingsBlock: FC<Props> = ({ status, count = 0, disable }) => {
  return (
    <Flex
      align="center"
      justify="space-between"
      className={classNames(s['block-wrapper'], {
        [s[status]]: !disable,
        [s.disable]: disable,
      })}
    >
      <Text className={s['block-title']}>{labels[status]}</Text>
      <Text className={s['block-count']}>{count}</Text>
    </Flex>
  );
};

export default ReadingsBlock;
